import { Box, Typography } from '@mui/material';

export const Item = ({
  label,
  value,
  color,
  alignItems = 'center'
}: {
  label: string;
  value: string | number;
  color?: string;
  alignItems?: string;
}) => {
  return (
    <Box display="flex" alignItems={alignItems}>
      <Typography sx={{ fontWeight: 600, color: color ?? '#000' }}>{label}</Typography>
      <Box marginLeft="5px">
        <Typography component="span" sx={{ color: color ?? '#000' }}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};
